import BsAlert from 'react-bootstrap/Alert'

function Alert({ children, ...otherProps }) {
  return <BsAlert {...otherProps}>{children}</BsAlert>
}

export default Alert
